// App.js
import React, { useState, useRef, useEffect } from 'react';
import './App.css';

// Les symboles du jeu (Assets logos)
const SECUTOP_SYMBOL = (
  <img
    className="symbol-image"
    src={`${process.env.PUBLIC_URL}/secutop-logo-crop.png`}
    alt="Secutop"
  />
);

const SIMPLX_SYMBOL = (
  <img
    className="symbol-image"
    src={`${process.env.PUBLIC_URL}/simplx_logo_graphic-only.png`}
    alt="SimplX"
  />
);

const SYMBOLS = ['🍒', '🍋', '🍇', '💎', '7️⃣', '🔔', '🍉', '⭐', SECUTOP_SYMBOL, SIMPLX_SYMBOL];

const SECURITY_CODE = '7777';
const STARTING_CREDITS = 30;

const SlotMachine = () => {
  // État des 3 rouleaux
  // const [reels, setReels] = useState(['7️⃣', '7️⃣', '7️⃣']);
  const [reels, setReels] = useState([SECUTOP_SYMBOL, SIMPLX_SYMBOL, SECUTOP_SYMBOL]);
  // État du jeu
  const [isSpinning, setIsSpinning] = useState(false);
  const [message, setMessage] = useState("Entrez le code pour jouer.");
  const [credits, setCredits] = useState(0);
  const [showWinPopup, setShowWinPopup] = useState(false);
  const [showCodePopup, setShowCodePopup] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [codeError, setCodeError] = useState('');
  const [leverState, setLeverState] = useState('idle'); // idle, down, up

  // Références pour gérer les intervalles d'animation
  const intervalRefs = useRef([]);
  const hasPromptedRef = useRef(false);
  const spinsSinceWinRef = useRef(0);

  // Fonction pour obtenir un symbole aléatoire
  const getRandomSymbol = () => SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)];

  const openCodePopup = () => {
    setShowCodePopup(true);
    setCodeInput('');
    setCodeError('');
    spinsSinceWinRef.current = 0;
    setCredits(0);
    setMessage('Entrez le code pour jouer.');
    setShowWinPopup(false);
  };

  const handleCodeSubmit = (event) => {
    event.preventDefault();
    const cleaned = codeInput.trim();

    if (cleaned === SECURITY_CODE) {
      setCredits(STARTING_CREDITS);
      setMessage('Bonne chance !');
      setShowCodePopup(false);
      setCodeError('');
      return;
    }

    setCodeError('Code incorrect. Veuillez réessayer.');
    setMessage('Code incorrect. Rechargez pour réessayer.');
  };

  useEffect(() => {
    if (hasPromptedRef.current) return;
    hasPromptedRef.current = true;
    openCodePopup();
  }, []);

  const startSpin = () => {
    if (showCodePopup) {
      setMessage('Entrez le code pour jouer.');
      return;
    }

    if (isSpinning || credits < 10) {
      if(credits < 10) setMessage("Pas assez de crédits ! Rechargez.");
      return;
    }

    // 1. Initialisation
    setIsSpinning(true);
    setShowWinPopup(false);
    setMessage("Bonne chance...");
    setCredits((prev) => prev - 10); // Coût de la partie
    
    // 2. Animation du levier
    setLeverState('down');
    setTimeout(() => setLeverState('up'), 300);
    setTimeout(() => setLeverState('idle'), 600);

    // 3. Lancement de l'animation des rouleaux (défilement rapide)
    const newIntervals = [0, 1, 2].map((index) => {
      return setInterval(() => {
        setReels((prevReels) => {
          const newReels = [...prevReels];
          newReels[index] = getRandomSymbol();
          return newReels;
        });
      }, 100); // Change de symbole toutes les 100ms
    });

    intervalRefs.current = newIntervals;

    // 4. Arrêt séquentiel des rouleaux pour l'effet de suspense
    const stopDelays = [2000, 2500, 3000]; // Temps d'arrêt pour chaque rouleau
    const nextSpinCount = spinsSinceWinRef.current + 1;
    const shouldWin = nextSpinCount >= 16 ? true : Math.random() < 1 / 16;
    let finalResult = [getRandomSymbol(), getRandomSymbol(), getRandomSymbol()];

    if (shouldWin) {
      const winSymbol = getRandomSymbol();
      finalResult = [winSymbol, winSymbol, winSymbol];
      spinsSinceWinRef.current = 0;
    } else if (finalResult[0] === finalResult[1] && finalResult[1] === finalResult[2]) {
      let differentSymbol = getRandomSymbol();
      while (differentSymbol === finalResult[0]) {
        differentSymbol = getRandomSymbol();
      }
      finalResult[2] = differentSymbol;
      spinsSinceWinRef.current = nextSpinCount;
    } else {
      spinsSinceWinRef.current = nextSpinCount;
    }
    
    // Pour tricher et tester la victoire, décommente la ligne ci-dessous :
    // const finalResult = ['💎', '💎', '💎']; 

    stopDelays.forEach((delay, index) => {
      setTimeout(() => {
        clearInterval(intervalRefs.current[index]); // Arrête le défilement
        setReels((prev) => {
          const newReels = [...prev];
          newReels[index] = finalResult[index]; // Fixe le résultat final
          return newReels;
        });

        // Si c'est le dernier rouleau, on vérifie le résultat
        if (index === 2) {
          checkWin(finalResult);
          setIsSpinning(false);
        }
      }, delay);
    });
  };

  const checkWin = (result) => {
    if (result[0] === result[1] && result[1] === result[2]) {
      setMessage("JACKTOP !!!");
      setShowWinPopup(true);
    } else {
      setMessage("Perdu, essayez encore !");
    }
  };

  const resetGame = () => {
    openCodePopup();
  };

  return (
    <div className="main-container">

      <div className="sponsors">
        <div className="sponsors-logos">
          <img
            className="sponsor-logo"
            src={`${process.env.PUBLIC_URL}/simplx_logo_white_text.png`}
            alt="SimplX"
          />
          <img
            className="sponsor-logo"
            src={`${process.env.PUBLIC_URL}/secutop-logo.png`}
            alt="Secutop"
          />
        </div>
        <div className="sponsors-text">présentent</div>
      </div>
      <div className="casino-machine">
        
        {/* Tête de la machine */}
        <div className="machine-header">
          <h1>🎰 LE GRAND JACKTOP 🎰</h1>
          <div className="lights-container">
            {[...Array(10)].map((_, i) => <div key={i} className="light blink"></div>)}
          </div>
        </div>

        {/* Écran des rouleaux */}
        <div className="reels-container">
          <div className="reel-window">
            {reels.map((symbol, index) => (
              <div key={index} className={`reel ${isSpinning ? 'blur-anim' : ''}`}>
                {symbol}
              </div>
            ))}
            <div className="payline"></div> {/* Ligne rouge centrale */}
          </div>
        </div>

        {/* Panneau de contrôle bas */}
        <div className="control-panel">
          <div className="display-box">
            <span>CRÉDITS: {credits}</span>
          </div>
          <div className="display-box message-box">
            <span>{message}</span>
          </div>
        </div>

        {/* Le Levier (Bras mécanique) */}
        <div className="lever-container">
          <div className="lever-base"></div>
          <div className={`lever-stick ${leverState}`} onClick={startSpin}>
            <div className="lever-knob"></div>
          </div>
        </div>

      </div>

      {/* Popup Code Securite */}
      {showCodePopup && (
        <div className="overlay">
          <div className="popup code-popup">
            <h2>Accès sécurisé</h2>
            <p>Entrez le code pour jouer.</p>
            <form className="code-form" onSubmit={handleCodeSubmit}>
              <input
                className="code-input"
                type="password"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="4"
                value={codeInput}
                onChange={(event) => setCodeInput(event.target.value)}
                autoFocus
              />
              <button type="submit">Valider</button>
            </form>
            {codeError && <div className="code-error">{codeError}</div>}
          </div>
        </div>
      )}

      {/* Popup Gagnant */}
      {showWinPopup && (
        <div className="overlay">
          <div className="popup">
            <h2>🎉 VICTOIRE ! 🎉</h2>
            <p>Vous avez aligné 3 symboles identiques !</p>
            <div className="win-symbol">{reels[0]}</div>
            <p>Vous gagnez un goodies!</p>
            <button onClick={() => setShowWinPopup(false)}>Continuer</button>
          </div>
        </div>
      )}

      {/* Bouton reset si fauché */}
      {credits < 10 && !isSpinning && (
        <button className="reset-btn" onClick={resetGame}>Remettre des pièces 🪙</button>
      )}

      <div className="sponsors-text" style={{ margin: "20px" }}>You will never play alone</div>
    </div>
  );
};

export default SlotMachine;
